/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CalendarLinkCreateDTO } from '../models';
// @ts-ignore
import type { CalendarLinkResponseDTO } from '../models';
// @ts-ignore
import type { CalendarLinkUpdateDTO } from '../models';
// @ts-ignore
import type { GoogleCalendarDTO } from '../models';
// @ts-ignore
import type { GoogleConnectionResponseDTO } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { OAuthStateResponseDTO } from '../models';
// @ts-ignore
import type { SyncResultDTO } from '../models';
/**
 * GoogleCalendarApi - axios parameter creator
 * @export
 */
export const GoogleCalendarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Link a Google Calendar to internal calendar(s).  Creates a CalendarLink with junction records to internal calendars. Automatically registers a webhook watch channel if configured.  Requires \'integration:write\' permission.
         * @summary Create Calendar Link
         * @param {CalendarLinkCreateDTO} calendarLinkCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalendarLinkApiV1GoogleCalendarLinksPost: async (calendarLinkCreateDTO: CalendarLinkCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarLinkCreateDTO' is not null or undefined
            assertParamExists('createCalendarLinkApiV1GoogleCalendarLinksPost', 'calendarLinkCreateDTO', calendarLinkCreateDTO)
            const localVarPath = `/api/v1/google-calendar/links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarLinkCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Link a Google Calendar to internal calendar(s).  Creates a CalendarLink with junction records to internal calendars. Automatically registers a webhook watch channel if configured.  Requires \'integration:write\' permission.
         * @summary Create Calendar Link
         * @param {CalendarLinkCreateDTO} calendarLinkCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalendarLinkApiV1GoogleCalendarLinksPost_1: async (calendarLinkCreateDTO: CalendarLinkCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarLinkCreateDTO' is not null or undefined
            assertParamExists('createCalendarLinkApiV1GoogleCalendarLinksPost_1', 'calendarLinkCreateDTO', calendarLinkCreateDTO)
            const localVarPath = `/api/v1/google-calendar/links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarLinkCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unlink a calendar and stop associated watch channels.  Requires \'integration:write\' permission.
         * @summary Delete Calendar Link
         * @param {string} linkId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalendarLinkApiV1GoogleCalendarLinksLinkIdDelete: async (linkId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkId' is not null or undefined
            assertParamExists('deleteCalendarLinkApiV1GoogleCalendarLinksLinkIdDelete', 'linkId', linkId)
            const localVarPath = `/api/v1/google-calendar/links/{link_id}`
                .replace(`{${"link_id"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unlink a calendar and stop associated watch channels.  Requires \'integration:write\' permission.
         * @summary Delete Calendar Link
         * @param {string} linkId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalendarLinkApiV1GoogleCalendarLinksLinkIdDelete_2: async (linkId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkId' is not null or undefined
            assertParamExists('deleteCalendarLinkApiV1GoogleCalendarLinksLinkIdDelete_2', 'linkId', linkId)
            const localVarPath = `/api/v1/google-calendar/links/{link_id}`
                .replace(`{${"link_id"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Disconnect a Google account (revoke tokens + cleanup).  Requires \'integration:write\' permission.
         * @summary Disconnect
         * @param {string} connectionId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectApiV1GoogleCalendarConnectionsConnectionIdDelete: async (connectionId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('disconnectApiV1GoogleCalendarConnectionsConnectionIdDelete', 'connectionId', connectionId)
            const localVarPath = `/api/v1/google-calendar/connections/{connection_id}`
                .replace(`{${"connection_id"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Disconnect a Google account (revoke tokens + cleanup).  Requires \'integration:write\' permission.
         * @summary Disconnect
         * @param {string} connectionId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectApiV1GoogleCalendarConnectionsConnectionIdDelete_3: async (connectionId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('disconnectApiV1GoogleCalendarConnectionsConnectionIdDelete_3', 'connectionId', connectionId)
            const localVarPath = `/api/v1/google-calendar/connections/{connection_id}`
                .replace(`{${"connection_id"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate Google OAuth authorization URL.  Creates a state token stored in Redis for CSRF protection and returns the authorization URL the frontend should redirect to.  Requires \'integration:write\' permission.
         * @summary Get Auth Url
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthUrlApiV1GoogleCalendarAuthUrlGet: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/google-calendar/auth/url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate Google OAuth authorization URL.  Creates a state token stored in Redis for CSRF protection and returns the authorization URL the frontend should redirect to.  Requires \'integration:write\' permission.
         * @summary Get Auth Url
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthUrlApiV1GoogleCalendarAuthUrlGet_4: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/google-calendar/auth/url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all calendar links for the current organization.  Requires \'integration:view\' permission.
         * @summary List Calendar Links
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCalendarLinksApiV1GoogleCalendarLinksGet: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/google-calendar/links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all calendar links for the current organization.  Requires \'integration:view\' permission.
         * @summary List Calendar Links
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCalendarLinksApiV1GoogleCalendarLinksGet_5: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/google-calendar/links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all Google Calendar connections for the current organization.  Requires \'integration:view\' permission.
         * @summary List Connections
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectionsApiV1GoogleCalendarConnectionsGet: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/google-calendar/connections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all Google Calendar connections for the current organization.  Requires \'integration:view\' permission.
         * @summary List Connections
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectionsApiV1GoogleCalendarConnectionsGet_6: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/google-calendar/connections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List available Google Calendars for a connection.  Fetches the calendar list directly from Google Calendar API.  Requires \'integration:view\' permission.
         * @summary List Google Calendars
         * @param {string} connectionId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGoogleCalendarsApiV1GoogleCalendarConnectionsConnectionIdCalendarsGet: async (connectionId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('listGoogleCalendarsApiV1GoogleCalendarConnectionsConnectionIdCalendarsGet', 'connectionId', connectionId)
            const localVarPath = `/api/v1/google-calendar/connections/{connection_id}/calendars`
                .replace(`{${"connection_id"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List available Google Calendars for a connection.  Fetches the calendar list directly from Google Calendar API.  Requires \'integration:view\' permission.
         * @summary List Google Calendars
         * @param {string} connectionId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGoogleCalendarsApiV1GoogleCalendarConnectionsConnectionIdCalendarsGet_7: async (connectionId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('listGoogleCalendarsApiV1GoogleCalendarConnectionsConnectionIdCalendarsGet_7', 'connectionId', connectionId)
            const localVarPath = `/api/v1/google-calendar/connections/{connection_id}/calendars`
                .replace(`{${"connection_id"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle Google OAuth callback.  Validates the state parameter, exchanges the authorization code for tokens, creates the GoogleConnection, and redirects the user to the frontend callback page with the result as query parameters.  This endpoint is called by Google after the user authorizes access.
         * @summary Oauth Callback
         * @param {string} code Authorization code from Google
         * @param {string} state CSRF state parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauthCallbackApiV1GoogleCalendarCallbackGet: async (code: string, state: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('oauthCallbackApiV1GoogleCalendarCallbackGet', 'code', code)
            // verify required parameter 'state' is not null or undefined
            assertParamExists('oauthCallbackApiV1GoogleCalendarCallbackGet', 'state', state)
            const localVarPath = `/api/v1/google-calendar/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle Google OAuth callback.  Validates the state parameter, exchanges the authorization code for tokens, creates the GoogleConnection, and redirects the user to the frontend callback page with the result as query parameters.  This endpoint is called by Google after the user authorizes access.
         * @summary Oauth Callback
         * @param {string} code Authorization code from Google
         * @param {string} state CSRF state parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauthCallbackApiV1GoogleCalendarCallbackGet_8: async (code: string, state: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('oauthCallbackApiV1GoogleCalendarCallbackGet_8', 'code', code)
            // verify required parameter 'state' is not null or undefined
            assertParamExists('oauthCallbackApiV1GoogleCalendarCallbackGet_8', 'state', state)
            const localVarPath = `/api/v1/google-calendar/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Trigger a manual sync for a calendar link.  Performs an incremental sync if a sync token exists, otherwise performs a full sync.  Requires \'integration:write\' permission.
         * @summary Trigger Sync
         * @param {string} linkId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerSyncApiV1GoogleCalendarLinksLinkIdSyncPost: async (linkId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkId' is not null or undefined
            assertParamExists('triggerSyncApiV1GoogleCalendarLinksLinkIdSyncPost', 'linkId', linkId)
            const localVarPath = `/api/v1/google-calendar/links/{link_id}/sync`
                .replace(`{${"link_id"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Trigger a manual sync for a calendar link.  Performs an incremental sync if a sync token exists, otherwise performs a full sync.  Requires \'integration:write\' permission.
         * @summary Trigger Sync
         * @param {string} linkId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerSyncApiV1GoogleCalendarLinksLinkIdSyncPost_9: async (linkId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkId' is not null or undefined
            assertParamExists('triggerSyncApiV1GoogleCalendarLinksLinkIdSyncPost_9', 'linkId', linkId)
            const localVarPath = `/api/v1/google-calendar/links/{link_id}/sync`
                .replace(`{${"link_id"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a calendar link (enable/disable sync).  Requires \'integration:write\' permission.
         * @summary Update Calendar Link
         * @param {string} linkId 
         * @param {CalendarLinkUpdateDTO} calendarLinkUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch: async (linkId: string, calendarLinkUpdateDTO: CalendarLinkUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkId' is not null or undefined
            assertParamExists('updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch', 'linkId', linkId)
            // verify required parameter 'calendarLinkUpdateDTO' is not null or undefined
            assertParamExists('updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch', 'calendarLinkUpdateDTO', calendarLinkUpdateDTO)
            const localVarPath = `/api/v1/google-calendar/links/{link_id}`
                .replace(`{${"link_id"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarLinkUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a calendar link (enable/disable sync).  Requires \'integration:write\' permission.
         * @summary Update Calendar Link
         * @param {string} linkId 
         * @param {CalendarLinkUpdateDTO} calendarLinkUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch_10: async (linkId: string, calendarLinkUpdateDTO: CalendarLinkUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkId' is not null or undefined
            assertParamExists('updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch_10', 'linkId', linkId)
            // verify required parameter 'calendarLinkUpdateDTO' is not null or undefined
            assertParamExists('updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch_10', 'calendarLinkUpdateDTO', calendarLinkUpdateDTO)
            const localVarPath = `/api/v1/google-calendar/links/{link_id}`
                .replace(`{${"link_id"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarLinkUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GoogleCalendarApi - functional programming interface
 * @export
 */
export const GoogleCalendarApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GoogleCalendarApiAxiosParamCreator(configuration)
    return {
        /**
         * Link a Google Calendar to internal calendar(s).  Creates a CalendarLink with junction records to internal calendars. Automatically registers a webhook watch channel if configured.  Requires \'integration:write\' permission.
         * @summary Create Calendar Link
         * @param {CalendarLinkCreateDTO} calendarLinkCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCalendarLinkApiV1GoogleCalendarLinksPost(calendarLinkCreateDTO: CalendarLinkCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarLinkResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCalendarLinkApiV1GoogleCalendarLinksPost(calendarLinkCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.createCalendarLinkApiV1GoogleCalendarLinksPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Link a Google Calendar to internal calendar(s).  Creates a CalendarLink with junction records to internal calendars. Automatically registers a webhook watch channel if configured.  Requires \'integration:write\' permission.
         * @summary Create Calendar Link
         * @param {CalendarLinkCreateDTO} calendarLinkCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCalendarLinkApiV1GoogleCalendarLinksPost_1(calendarLinkCreateDTO: CalendarLinkCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarLinkResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCalendarLinkApiV1GoogleCalendarLinksPost_1(calendarLinkCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.createCalendarLinkApiV1GoogleCalendarLinksPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unlink a calendar and stop associated watch channels.  Requires \'integration:write\' permission.
         * @summary Delete Calendar Link
         * @param {string} linkId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCalendarLinkApiV1GoogleCalendarLinksLinkIdDelete(linkId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCalendarLinkApiV1GoogleCalendarLinksLinkIdDelete(linkId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.deleteCalendarLinkApiV1GoogleCalendarLinksLinkIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unlink a calendar and stop associated watch channels.  Requires \'integration:write\' permission.
         * @summary Delete Calendar Link
         * @param {string} linkId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCalendarLinkApiV1GoogleCalendarLinksLinkIdDelete_2(linkId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCalendarLinkApiV1GoogleCalendarLinksLinkIdDelete_2(linkId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.deleteCalendarLinkApiV1GoogleCalendarLinksLinkIdDelete_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Disconnect a Google account (revoke tokens + cleanup).  Requires \'integration:write\' permission.
         * @summary Disconnect
         * @param {string} connectionId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectApiV1GoogleCalendarConnectionsConnectionIdDelete(connectionId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectApiV1GoogleCalendarConnectionsConnectionIdDelete(connectionId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.disconnectApiV1GoogleCalendarConnectionsConnectionIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Disconnect a Google account (revoke tokens + cleanup).  Requires \'integration:write\' permission.
         * @summary Disconnect
         * @param {string} connectionId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectApiV1GoogleCalendarConnectionsConnectionIdDelete_3(connectionId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectApiV1GoogleCalendarConnectionsConnectionIdDelete_3(connectionId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.disconnectApiV1GoogleCalendarConnectionsConnectionIdDelete_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate Google OAuth authorization URL.  Creates a state token stored in Redis for CSRF protection and returns the authorization URL the frontend should redirect to.  Requires \'integration:write\' permission.
         * @summary Get Auth Url
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthUrlApiV1GoogleCalendarAuthUrlGet(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OAuthStateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthUrlApiV1GoogleCalendarAuthUrlGet(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.getAuthUrlApiV1GoogleCalendarAuthUrlGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate Google OAuth authorization URL.  Creates a state token stored in Redis for CSRF protection and returns the authorization URL the frontend should redirect to.  Requires \'integration:write\' permission.
         * @summary Get Auth Url
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthUrlApiV1GoogleCalendarAuthUrlGet_4(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OAuthStateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthUrlApiV1GoogleCalendarAuthUrlGet_4(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.getAuthUrlApiV1GoogleCalendarAuthUrlGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all calendar links for the current organization.  Requires \'integration:view\' permission.
         * @summary List Calendar Links
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCalendarLinksApiV1GoogleCalendarLinksGet(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarLinkResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCalendarLinksApiV1GoogleCalendarLinksGet(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.listCalendarLinksApiV1GoogleCalendarLinksGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all calendar links for the current organization.  Requires \'integration:view\' permission.
         * @summary List Calendar Links
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCalendarLinksApiV1GoogleCalendarLinksGet_5(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarLinkResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCalendarLinksApiV1GoogleCalendarLinksGet_5(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.listCalendarLinksApiV1GoogleCalendarLinksGet_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all Google Calendar connections for the current organization.  Requires \'integration:view\' permission.
         * @summary List Connections
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listConnectionsApiV1GoogleCalendarConnectionsGet(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GoogleConnectionResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listConnectionsApiV1GoogleCalendarConnectionsGet(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.listConnectionsApiV1GoogleCalendarConnectionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all Google Calendar connections for the current organization.  Requires \'integration:view\' permission.
         * @summary List Connections
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listConnectionsApiV1GoogleCalendarConnectionsGet_6(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GoogleConnectionResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listConnectionsApiV1GoogleCalendarConnectionsGet_6(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.listConnectionsApiV1GoogleCalendarConnectionsGet_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List available Google Calendars for a connection.  Fetches the calendar list directly from Google Calendar API.  Requires \'integration:view\' permission.
         * @summary List Google Calendars
         * @param {string} connectionId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGoogleCalendarsApiV1GoogleCalendarConnectionsConnectionIdCalendarsGet(connectionId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GoogleCalendarDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGoogleCalendarsApiV1GoogleCalendarConnectionsConnectionIdCalendarsGet(connectionId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.listGoogleCalendarsApiV1GoogleCalendarConnectionsConnectionIdCalendarsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List available Google Calendars for a connection.  Fetches the calendar list directly from Google Calendar API.  Requires \'integration:view\' permission.
         * @summary List Google Calendars
         * @param {string} connectionId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGoogleCalendarsApiV1GoogleCalendarConnectionsConnectionIdCalendarsGet_7(connectionId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GoogleCalendarDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGoogleCalendarsApiV1GoogleCalendarConnectionsConnectionIdCalendarsGet_7(connectionId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.listGoogleCalendarsApiV1GoogleCalendarConnectionsConnectionIdCalendarsGet_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle Google OAuth callback.  Validates the state parameter, exchanges the authorization code for tokens, creates the GoogleConnection, and redirects the user to the frontend callback page with the result as query parameters.  This endpoint is called by Google after the user authorizes access.
         * @summary Oauth Callback
         * @param {string} code Authorization code from Google
         * @param {string} state CSRF state parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async oauthCallbackApiV1GoogleCalendarCallbackGet(code: string, state: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.oauthCallbackApiV1GoogleCalendarCallbackGet(code, state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.oauthCallbackApiV1GoogleCalendarCallbackGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle Google OAuth callback.  Validates the state parameter, exchanges the authorization code for tokens, creates the GoogleConnection, and redirects the user to the frontend callback page with the result as query parameters.  This endpoint is called by Google after the user authorizes access.
         * @summary Oauth Callback
         * @param {string} code Authorization code from Google
         * @param {string} state CSRF state parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async oauthCallbackApiV1GoogleCalendarCallbackGet_8(code: string, state: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.oauthCallbackApiV1GoogleCalendarCallbackGet_8(code, state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.oauthCallbackApiV1GoogleCalendarCallbackGet_8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Trigger a manual sync for a calendar link.  Performs an incremental sync if a sync token exists, otherwise performs a full sync.  Requires \'integration:write\' permission.
         * @summary Trigger Sync
         * @param {string} linkId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerSyncApiV1GoogleCalendarLinksLinkIdSyncPost(linkId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncResultDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerSyncApiV1GoogleCalendarLinksLinkIdSyncPost(linkId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.triggerSyncApiV1GoogleCalendarLinksLinkIdSyncPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Trigger a manual sync for a calendar link.  Performs an incremental sync if a sync token exists, otherwise performs a full sync.  Requires \'integration:write\' permission.
         * @summary Trigger Sync
         * @param {string} linkId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerSyncApiV1GoogleCalendarLinksLinkIdSyncPost_9(linkId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncResultDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerSyncApiV1GoogleCalendarLinksLinkIdSyncPost_9(linkId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.triggerSyncApiV1GoogleCalendarLinksLinkIdSyncPost_9']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a calendar link (enable/disable sync).  Requires \'integration:write\' permission.
         * @summary Update Calendar Link
         * @param {string} linkId 
         * @param {CalendarLinkUpdateDTO} calendarLinkUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch(linkId: string, calendarLinkUpdateDTO: CalendarLinkUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarLinkResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch(linkId, calendarLinkUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a calendar link (enable/disable sync).  Requires \'integration:write\' permission.
         * @summary Update Calendar Link
         * @param {string} linkId 
         * @param {CalendarLinkUpdateDTO} calendarLinkUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch_10(linkId: string, calendarLinkUpdateDTO: CalendarLinkUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarLinkResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch_10(linkId, calendarLinkUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch_10']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GoogleCalendarApi - factory interface
 * @export
 */
export const GoogleCalendarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GoogleCalendarApiFp(configuration)
    return {
        /**
         * Link a Google Calendar to internal calendar(s).  Creates a CalendarLink with junction records to internal calendars. Automatically registers a webhook watch channel if configured.  Requires \'integration:write\' permission.
         * @summary Create Calendar Link
         * @param {CalendarLinkCreateDTO} calendarLinkCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalendarLinkApiV1GoogleCalendarLinksPost(calendarLinkCreateDTO: CalendarLinkCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CalendarLinkResponseDTO> {
            return localVarFp.createCalendarLinkApiV1GoogleCalendarLinksPost(calendarLinkCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Link a Google Calendar to internal calendar(s).  Creates a CalendarLink with junction records to internal calendars. Automatically registers a webhook watch channel if configured.  Requires \'integration:write\' permission.
         * @summary Create Calendar Link
         * @param {CalendarLinkCreateDTO} calendarLinkCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalendarLinkApiV1GoogleCalendarLinksPost_1(calendarLinkCreateDTO: CalendarLinkCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CalendarLinkResponseDTO> {
            return localVarFp.createCalendarLinkApiV1GoogleCalendarLinksPost_1(calendarLinkCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Unlink a calendar and stop associated watch channels.  Requires \'integration:write\' permission.
         * @summary Delete Calendar Link
         * @param {string} linkId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalendarLinkApiV1GoogleCalendarLinksLinkIdDelete(linkId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCalendarLinkApiV1GoogleCalendarLinksLinkIdDelete(linkId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Unlink a calendar and stop associated watch channels.  Requires \'integration:write\' permission.
         * @summary Delete Calendar Link
         * @param {string} linkId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalendarLinkApiV1GoogleCalendarLinksLinkIdDelete_2(linkId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCalendarLinkApiV1GoogleCalendarLinksLinkIdDelete_2(linkId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Disconnect a Google account (revoke tokens + cleanup).  Requires \'integration:write\' permission.
         * @summary Disconnect
         * @param {string} connectionId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectApiV1GoogleCalendarConnectionsConnectionIdDelete(connectionId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.disconnectApiV1GoogleCalendarConnectionsConnectionIdDelete(connectionId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Disconnect a Google account (revoke tokens + cleanup).  Requires \'integration:write\' permission.
         * @summary Disconnect
         * @param {string} connectionId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectApiV1GoogleCalendarConnectionsConnectionIdDelete_3(connectionId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.disconnectApiV1GoogleCalendarConnectionsConnectionIdDelete_3(connectionId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate Google OAuth authorization URL.  Creates a state token stored in Redis for CSRF protection and returns the authorization URL the frontend should redirect to.  Requires \'integration:write\' permission.
         * @summary Get Auth Url
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthUrlApiV1GoogleCalendarAuthUrlGet(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<OAuthStateResponseDTO> {
            return localVarFp.getAuthUrlApiV1GoogleCalendarAuthUrlGet(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate Google OAuth authorization URL.  Creates a state token stored in Redis for CSRF protection and returns the authorization URL the frontend should redirect to.  Requires \'integration:write\' permission.
         * @summary Get Auth Url
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthUrlApiV1GoogleCalendarAuthUrlGet_4(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<OAuthStateResponseDTO> {
            return localVarFp.getAuthUrlApiV1GoogleCalendarAuthUrlGet_4(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all calendar links for the current organization.  Requires \'integration:view\' permission.
         * @summary List Calendar Links
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCalendarLinksApiV1GoogleCalendarLinksGet(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalendarLinkResponseDTO>> {
            return localVarFp.listCalendarLinksApiV1GoogleCalendarLinksGet(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all calendar links for the current organization.  Requires \'integration:view\' permission.
         * @summary List Calendar Links
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCalendarLinksApiV1GoogleCalendarLinksGet_5(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalendarLinkResponseDTO>> {
            return localVarFp.listCalendarLinksApiV1GoogleCalendarLinksGet_5(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all Google Calendar connections for the current organization.  Requires \'integration:view\' permission.
         * @summary List Connections
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectionsApiV1GoogleCalendarConnectionsGet(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GoogleConnectionResponseDTO>> {
            return localVarFp.listConnectionsApiV1GoogleCalendarConnectionsGet(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all Google Calendar connections for the current organization.  Requires \'integration:view\' permission.
         * @summary List Connections
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectionsApiV1GoogleCalendarConnectionsGet_6(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GoogleConnectionResponseDTO>> {
            return localVarFp.listConnectionsApiV1GoogleCalendarConnectionsGet_6(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List available Google Calendars for a connection.  Fetches the calendar list directly from Google Calendar API.  Requires \'integration:view\' permission.
         * @summary List Google Calendars
         * @param {string} connectionId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGoogleCalendarsApiV1GoogleCalendarConnectionsConnectionIdCalendarsGet(connectionId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GoogleCalendarDTO>> {
            return localVarFp.listGoogleCalendarsApiV1GoogleCalendarConnectionsConnectionIdCalendarsGet(connectionId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List available Google Calendars for a connection.  Fetches the calendar list directly from Google Calendar API.  Requires \'integration:view\' permission.
         * @summary List Google Calendars
         * @param {string} connectionId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGoogleCalendarsApiV1GoogleCalendarConnectionsConnectionIdCalendarsGet_7(connectionId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GoogleCalendarDTO>> {
            return localVarFp.listGoogleCalendarsApiV1GoogleCalendarConnectionsConnectionIdCalendarsGet_7(connectionId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle Google OAuth callback.  Validates the state parameter, exchanges the authorization code for tokens, creates the GoogleConnection, and redirects the user to the frontend callback page with the result as query parameters.  This endpoint is called by Google after the user authorizes access.
         * @summary Oauth Callback
         * @param {string} code Authorization code from Google
         * @param {string} state CSRF state parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauthCallbackApiV1GoogleCalendarCallbackGet(code: string, state: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.oauthCallbackApiV1GoogleCalendarCallbackGet(code, state, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle Google OAuth callback.  Validates the state parameter, exchanges the authorization code for tokens, creates the GoogleConnection, and redirects the user to the frontend callback page with the result as query parameters.  This endpoint is called by Google after the user authorizes access.
         * @summary Oauth Callback
         * @param {string} code Authorization code from Google
         * @param {string} state CSRF state parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauthCallbackApiV1GoogleCalendarCallbackGet_8(code: string, state: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.oauthCallbackApiV1GoogleCalendarCallbackGet_8(code, state, options).then((request) => request(axios, basePath));
        },
        /**
         * Trigger a manual sync for a calendar link.  Performs an incremental sync if a sync token exists, otherwise performs a full sync.  Requires \'integration:write\' permission.
         * @summary Trigger Sync
         * @param {string} linkId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerSyncApiV1GoogleCalendarLinksLinkIdSyncPost(linkId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<SyncResultDTO> {
            return localVarFp.triggerSyncApiV1GoogleCalendarLinksLinkIdSyncPost(linkId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Trigger a manual sync for a calendar link.  Performs an incremental sync if a sync token exists, otherwise performs a full sync.  Requires \'integration:write\' permission.
         * @summary Trigger Sync
         * @param {string} linkId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerSyncApiV1GoogleCalendarLinksLinkIdSyncPost_9(linkId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<SyncResultDTO> {
            return localVarFp.triggerSyncApiV1GoogleCalendarLinksLinkIdSyncPost_9(linkId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a calendar link (enable/disable sync).  Requires \'integration:write\' permission.
         * @summary Update Calendar Link
         * @param {string} linkId 
         * @param {CalendarLinkUpdateDTO} calendarLinkUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch(linkId: string, calendarLinkUpdateDTO: CalendarLinkUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CalendarLinkResponseDTO> {
            return localVarFp.updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch(linkId, calendarLinkUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a calendar link (enable/disable sync).  Requires \'integration:write\' permission.
         * @summary Update Calendar Link
         * @param {string} linkId 
         * @param {CalendarLinkUpdateDTO} calendarLinkUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch_10(linkId: string, calendarLinkUpdateDTO: CalendarLinkUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CalendarLinkResponseDTO> {
            return localVarFp.updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch_10(linkId, calendarLinkUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GoogleCalendarApi - object-oriented interface
 * @export
 * @class GoogleCalendarApi
 * @extends {BaseAPI}
 */
export class GoogleCalendarApi extends BaseAPI {
    /**
     * Link a Google Calendar to internal calendar(s).  Creates a CalendarLink with junction records to internal calendars. Automatically registers a webhook watch channel if configured.  Requires \'integration:write\' permission.
     * @summary Create Calendar Link
     * @param {CalendarLinkCreateDTO} calendarLinkCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public createCalendarLinkApiV1GoogleCalendarLinksPost(calendarLinkCreateDTO: CalendarLinkCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).createCalendarLinkApiV1GoogleCalendarLinksPost(calendarLinkCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Link a Google Calendar to internal calendar(s).  Creates a CalendarLink with junction records to internal calendars. Automatically registers a webhook watch channel if configured.  Requires \'integration:write\' permission.
     * @summary Create Calendar Link
     * @param {CalendarLinkCreateDTO} calendarLinkCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public createCalendarLinkApiV1GoogleCalendarLinksPost_1(calendarLinkCreateDTO: CalendarLinkCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).createCalendarLinkApiV1GoogleCalendarLinksPost_1(calendarLinkCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unlink a calendar and stop associated watch channels.  Requires \'integration:write\' permission.
     * @summary Delete Calendar Link
     * @param {string} linkId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public deleteCalendarLinkApiV1GoogleCalendarLinksLinkIdDelete(linkId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).deleteCalendarLinkApiV1GoogleCalendarLinksLinkIdDelete(linkId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unlink a calendar and stop associated watch channels.  Requires \'integration:write\' permission.
     * @summary Delete Calendar Link
     * @param {string} linkId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public deleteCalendarLinkApiV1GoogleCalendarLinksLinkIdDelete_2(linkId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).deleteCalendarLinkApiV1GoogleCalendarLinksLinkIdDelete_2(linkId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Disconnect a Google account (revoke tokens + cleanup).  Requires \'integration:write\' permission.
     * @summary Disconnect
     * @param {string} connectionId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public disconnectApiV1GoogleCalendarConnectionsConnectionIdDelete(connectionId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).disconnectApiV1GoogleCalendarConnectionsConnectionIdDelete(connectionId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Disconnect a Google account (revoke tokens + cleanup).  Requires \'integration:write\' permission.
     * @summary Disconnect
     * @param {string} connectionId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public disconnectApiV1GoogleCalendarConnectionsConnectionIdDelete_3(connectionId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).disconnectApiV1GoogleCalendarConnectionsConnectionIdDelete_3(connectionId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate Google OAuth authorization URL.  Creates a state token stored in Redis for CSRF protection and returns the authorization URL the frontend should redirect to.  Requires \'integration:write\' permission.
     * @summary Get Auth Url
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public getAuthUrlApiV1GoogleCalendarAuthUrlGet(authorization?: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).getAuthUrlApiV1GoogleCalendarAuthUrlGet(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate Google OAuth authorization URL.  Creates a state token stored in Redis for CSRF protection and returns the authorization URL the frontend should redirect to.  Requires \'integration:write\' permission.
     * @summary Get Auth Url
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public getAuthUrlApiV1GoogleCalendarAuthUrlGet_4(authorization?: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).getAuthUrlApiV1GoogleCalendarAuthUrlGet_4(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all calendar links for the current organization.  Requires \'integration:view\' permission.
     * @summary List Calendar Links
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public listCalendarLinksApiV1GoogleCalendarLinksGet(authorization?: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).listCalendarLinksApiV1GoogleCalendarLinksGet(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all calendar links for the current organization.  Requires \'integration:view\' permission.
     * @summary List Calendar Links
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public listCalendarLinksApiV1GoogleCalendarLinksGet_5(authorization?: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).listCalendarLinksApiV1GoogleCalendarLinksGet_5(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all Google Calendar connections for the current organization.  Requires \'integration:view\' permission.
     * @summary List Connections
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public listConnectionsApiV1GoogleCalendarConnectionsGet(authorization?: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).listConnectionsApiV1GoogleCalendarConnectionsGet(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all Google Calendar connections for the current organization.  Requires \'integration:view\' permission.
     * @summary List Connections
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public listConnectionsApiV1GoogleCalendarConnectionsGet_6(authorization?: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).listConnectionsApiV1GoogleCalendarConnectionsGet_6(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List available Google Calendars for a connection.  Fetches the calendar list directly from Google Calendar API.  Requires \'integration:view\' permission.
     * @summary List Google Calendars
     * @param {string} connectionId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public listGoogleCalendarsApiV1GoogleCalendarConnectionsConnectionIdCalendarsGet(connectionId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).listGoogleCalendarsApiV1GoogleCalendarConnectionsConnectionIdCalendarsGet(connectionId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List available Google Calendars for a connection.  Fetches the calendar list directly from Google Calendar API.  Requires \'integration:view\' permission.
     * @summary List Google Calendars
     * @param {string} connectionId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public listGoogleCalendarsApiV1GoogleCalendarConnectionsConnectionIdCalendarsGet_7(connectionId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).listGoogleCalendarsApiV1GoogleCalendarConnectionsConnectionIdCalendarsGet_7(connectionId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle Google OAuth callback.  Validates the state parameter, exchanges the authorization code for tokens, creates the GoogleConnection, and redirects the user to the frontend callback page with the result as query parameters.  This endpoint is called by Google after the user authorizes access.
     * @summary Oauth Callback
     * @param {string} code Authorization code from Google
     * @param {string} state CSRF state parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public oauthCallbackApiV1GoogleCalendarCallbackGet(code: string, state: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).oauthCallbackApiV1GoogleCalendarCallbackGet(code, state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle Google OAuth callback.  Validates the state parameter, exchanges the authorization code for tokens, creates the GoogleConnection, and redirects the user to the frontend callback page with the result as query parameters.  This endpoint is called by Google after the user authorizes access.
     * @summary Oauth Callback
     * @param {string} code Authorization code from Google
     * @param {string} state CSRF state parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public oauthCallbackApiV1GoogleCalendarCallbackGet_8(code: string, state: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).oauthCallbackApiV1GoogleCalendarCallbackGet_8(code, state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Trigger a manual sync for a calendar link.  Performs an incremental sync if a sync token exists, otherwise performs a full sync.  Requires \'integration:write\' permission.
     * @summary Trigger Sync
     * @param {string} linkId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public triggerSyncApiV1GoogleCalendarLinksLinkIdSyncPost(linkId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).triggerSyncApiV1GoogleCalendarLinksLinkIdSyncPost(linkId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Trigger a manual sync for a calendar link.  Performs an incremental sync if a sync token exists, otherwise performs a full sync.  Requires \'integration:write\' permission.
     * @summary Trigger Sync
     * @param {string} linkId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public triggerSyncApiV1GoogleCalendarLinksLinkIdSyncPost_9(linkId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).triggerSyncApiV1GoogleCalendarLinksLinkIdSyncPost_9(linkId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a calendar link (enable/disable sync).  Requires \'integration:write\' permission.
     * @summary Update Calendar Link
     * @param {string} linkId 
     * @param {CalendarLinkUpdateDTO} calendarLinkUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch(linkId: string, calendarLinkUpdateDTO: CalendarLinkUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch(linkId, calendarLinkUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a calendar link (enable/disable sync).  Requires \'integration:write\' permission.
     * @summary Update Calendar Link
     * @param {string} linkId 
     * @param {CalendarLinkUpdateDTO} calendarLinkUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleCalendarApi
     */
    public updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch_10(linkId: string, calendarLinkUpdateDTO: CalendarLinkUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).updateCalendarLinkApiV1GoogleCalendarLinksLinkIdPatch_10(linkId, calendarLinkUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

